import { useTranslation } from "react-i18next";

/** Shown instead of the app when /config.json is missing or invalid. */
export function ConfigErrorPage({ message }: { message: string }) {
  const { t } = useTranslation();
  return (
    <main className="mx-auto max-w-xl p-8">
      <h1 className="text-lg font-semibold">{t("app.cannotStart")}</h1>
      <p role="alert" className="mt-2 text-sm">
        {message}
      </p>
    </main>
  );
}
